import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SlideDrawer from "./common/SlideDrawer";
import Clickable from "./common/Clickable";
import NotificationRulesPanel from "./settings/NotificationRulesPanel";
import MySignaturePanel from "./settings/MySignaturePanel";
import SignersPanel from "./settings/SignersPanel";
import HsbcKeysPanel from "./settings/HsbcKeysPanel";
import DigitalSignatureTab from "./settings/DigitalSignatureTab";
import DimensionRulesPanel from "./settings/DimensionRulesPanel";
import ReminderSettingsCard from "../../settings/reminders/ReminderSettingsCard";

// Settings của Payment Request — drawer trượt từ dưới lên.
//  • My signature: mọi user (tạo/quản lý chữ ký qua Hub-Sign) — cần để ký phiếu.
//  • Notifications: chỉ admin (site → kế toán nhận thông báo sau khi Manager duyệt).
//  • Digital signature: chỉ admin (Hub-Sign + VNPT SmartCA).
//  • Reminders: chỉ admin — chính là App Settings → Reminders → Payment requests (component dùng chung).
const PaymentRequestSettingsModal = ({ show, onHide, isAdmin = false, initialTab = "signature" }) => {
  const [tab, setTab] = useState(initialTab);
  // Opened from a link ("Settings → HSBC"): start on that tab.
  useEffect(() => { if (show) setTab(initialTab); }, [show, initialTab]);
  const active = !isAdmin ? "signature" : tab;

  const TABS = [
    { key: "signature", label: "My signature", icon: "bi-vector-pen" },
    ...(isAdmin ? [
      { key: "signers", label: "Signers", icon: "bi-person-check" },
      { key: "digital_signature", label: "Digital signature", icon: "bi-shield-lock" },
      { key: "notifications", label: "Notifications", icon: "bi-bell" },
      { key: "reminders", label: "Reminders", icon: "bi-alarm" },
      { key: "hsbc_keys", label: "HSBC", icon: "bi-bank" },
      { key: "erp_dimensions", label: "ERP dimensions", icon: "bi-diagram-3" },
    ] : []),
  ];

  return (
    <SlideDrawer
      show={show}
      onHide={onHide}
      placement="bottom"
      height="90vh"
      fixedHeight
      bodyClassName="tw-bg-geist-bg-2"
      title={
        <div className="tw-flex tw-items-center tw-gap-2">
          <i className="bi bi-gear tw-text-geist-fg-3" />
          <span className="tw-text-base tw-font-bold tw-text-geist-fg">Payment Request — Settings</span>
        </div>
      }
    >
      {/* Tabs — chỉ hiện khi có nhiều hơn 1 (admin). */}
      {TABS.length > 1 && (
        <div className="tw-inline-flex tw-flex-wrap tw-items-center tw-gap-1 tw-p-1 tw-mb-4 tw-rounded-geist-md tw-bg-geist-100">
          {TABS.map((t) => (
            <Clickable key={t.key} onClick={() => setTab(t.key)}
              className={`tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-rounded-[4px] tw-transition ${
                active === t.key ? "tw-bg-geist-bg tw-text-geist-fg tw-shadow-geist-card" : "tw-text-geist-fg-3 hover:tw-text-geist-fg"
              }`}>
              <i className={`bi ${t.icon} tw-text-[11px]`} /> {t.label}
            </Clickable>
          ))}
        </div>
      )}

      {active === "notifications" ? <NotificationRulesPanel />
        : active === "signers" ? <SignersPanel />
          : active === "digital_signature" ? <DigitalSignatureTab />
          : active === "hsbc_keys" ? <HsbcKeysPanel />
          : active === "erp_dimensions" ? <DimensionRulesPanel />
          : active === "reminders" ? <ReminderSettingsCard reminderKey="payment_request" />
            : <MySignaturePanel />}
    </SlideDrawer>
  );
};

PaymentRequestSettingsModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
  initialTab: PropTypes.string,
};

export default PaymentRequestSettingsModal;
